// extracted by mini-css-extract-plugin
export default {"detailsGrid":"DrawerInfoGrid_detailsGrid__hiPd2"};